import {formatText} from "../../../tools/format-text";

export const bindInputMask = ({value, onChange}, formatMask = '' ) => ({
    value: value || "",
    onChange: (e) => onChange(
        formatMask !== "" ? (
            formatText(formatMask, e.target.value)
        ) : (
            e.target.value
        )
    ),
});
